import React, { FunctionComponent, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { RootStore, Collection } from '../app/types';
import { CollectionGallery } from './CollectionGallery';

export const Publications: FunctionComponent = () => {
    // Select primitives/arrays directly to avoid creating new object references
    const collections = useSelector((state: RootStore) => state.collections);
    const showUnpublished = useSelector((state: RootStore) => state.showUnpublishedCollections);

    // Memoize sorted and filtered collections to avoid recalculating on every render
    const visibleCollections = useMemo(() => {
        return [...collections]
            .sort((a: Collection, b: Collection) => a.orderIndex - b.orderIndex)
            .filter((c: Collection) => c.published || showUnpublished);
    }, [collections, showUnpublished]);

    return (
        <div>
            {visibleCollections.map((c: Collection) => (
                <CollectionGallery key={c.ID} collectionID={c.ID} />
            ))}
        </div>
    );
}
